import { useState, useRef, useEffect } from 'react';
import LoadingComponent from "@/pcomponents/common/content/loading";
import XcolumnFunc from '@/pcomponents/common/xcolumn/xcolumn/xcolumn_func';
import DateFunc from '@/lib/lyg/date_func';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import { useSelector, useDispatch } from 'react-redux';
import strFunc from '@/lib/lyg/string';
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup';
import SendSmsEachPopup from "@/pages/comp/basic/sms/popup/send_sms_each";
import SendLocalKatalkPopup from "@/pages/comp/basic/katalk/local_katalk/popup/send_local_katalk";
import SendLocalKatalkCounselPopup from "@/pages/comp/basic/katalk/local_katalk/popup/send_local_katalk_counsel";
import ViewCounselTodoOfDay from "@/pages/comp/basic/counsel/calendar/area/popup/view_ctodo_day";
import TodoInfoArrFunc from "@/pcomponents/common/content/todo/list/info_arr_func";
import FocusBlurByScroll from "@/pcomponents/common/crud/write/input_func/focus_blur_by_scroll";
import DailyReportTextListFunc from "./func/list_func";
import CardListArea from "./area/card_list";
import Style from "./css/style.module.css";

function DailyReportTextListPopup(props: any) {
  let myProps = {
    select_date: "",
    stu_info_arr: [],
    closePopup: () => { },
    ...props
  };
  let user = useSelector((state: any) => state.user);
  let now_date_str = DateFunc.get_date_format(new Date(), "Y-m-d");
  let is_use_comp_study_textbook = user.comp_sort_detail == "growple" ? true : false;
  let select_date = myProps.select_date;
  if (strFunc.is_empty(select_date)) {
    select_date = now_date_str;
  }
  const content_scroll_ref = useRef<any>(null);
  const [stu_info_arr, set_stu_info_arr] = useState<any>([]);
  const [check_seq_arr, set_check_seq_arr] = useState([]);
  const [loading_data, set_loading_data] = useState({
    is_display: false,
    text: "로딩중..",
  });
  const [counsel_todo_arr, set_counsel_todo_arr] = useState([]);
  const [check_counsel_seq_arr, set_check_counsel_seq_arr] = useState([]);
  const [temp_memo_arr, set_temp_memo_arr] = useState<any>([]);
  const [user_link_arr, set_user_link_arr] = useState<any>([]);
  const [stu_par_report_arr, set_stu_par_report_arr] = useState<any>([]);
  const [mcomp_info, set_mcomp_info] = useState<any>({});
  let is_exist_katalk_send = false;
  if (mcomp_info && mcomp_info.addon_data_info
    && !strFunc.is_empty(mcomp_info.addon_data_info.a_infobank_katalk_sender_seq)) {
    is_exist_katalk_send = true;
  }
  let select_stu_grade_option_arr = XcolumnFunc.getSortByTableKey({ 'table': 'user', 'key': 'a_stu_grade' });

  const [popupData, setPopupData] = useState({
    isOpen: false,
    sort: "view_ctodo",//send_sms_each,send_local_katalk
    stu_info_arr: [],
    select_date: select_date,
    sms_data_arr: [],
    msg_arr: [],//[{room_name:"",message:""}]
    counsel_todo_pri_val_arr: [],
    has_header: true,
    title: "팝업",
    width: "800px",
    height: "85%",
  });

  useEffect(() => {
    if (document.getElementsByClassName("popup-content-div")[0]) {
      let popup_content_div: any = document.getElementsByClassName("popup-content-div")[0];
      popup_content_div.style.background = "#f4f0ff";
    }
    if (document.getElementsByClassName("popup-title-bar")[0]) {
      let popup_title_bar: any = document.getElementsByClassName("popup-title-bar")[0];
      popup_title_bar.style.color = "#ea5a2f";
    }

    let new_stu_info_arr = [...myProps.stu_info_arr];
    get_user_arr_by_ajax({ stu_info_arr: new_stu_info_arr });
    get_mcomp_info_by_ajax();
  }, [user]);

  useEffect(() => {
    if (content_scroll_ref.current) {
      FocusBlurByScroll.add_event({
        scroll_obj: content_scroll_ref.current,
      });
    }
  }, []);
  
  const check_all_stu = (e: any) => {
    let tmp_arr: any = [];
    if (e.target.checked) {
      for (let i = 0; i < stu_info_arr.length; i++) {
        tmp_arr.push(stu_info_arr[i]["a_seq"]);
      }
    }
    set_check_seq_arr(tmp_arr);
  };

  const check_all_counsel = (e: any) => {
    let tmp_arr: any = [];
    if (e.target.checked) {
      for (let i = 0; i < stu_info_arr.length; i++) {
        let row_stu_info = stu_info_arr[i];
        let row_counsel_todo = null;
        if (row_stu_info["counsel_todo_arr"] && row_stu_info["counsel_todo_arr"].length > 0) {
          row_counsel_todo = row_stu_info["counsel_todo_arr"][0];
        }
        if (row_stu_info["counsel_todo"]) {
          row_counsel_todo = row_stu_info["counsel_todo"];
        }

        if (row_counsel_todo) {
          let tmp_counsel_pri_val = row_counsel_todo["a_ymd"] + "," + row_counsel_todo["a_seq"];
          tmp_arr.push(tmp_counsel_pri_val);
        }
      }
    }
    set_check_counsel_seq_arr(tmp_arr);
  };

  const get_user_arr_by_ajax = (inData: any) => {
    let opt_obj = {
      stu_info_arr: myProps.stu_info_arr,
      ...inData
    };

    let s_stu_seq_arr = [];
    for (let i = 0; i < opt_obj.stu_info_arr.length; i++) {
      s_stu_seq_arr.push(opt_obj.stu_info_arr[i]["a_seq"]);
    }

    let form_json_data: any = {
      order_id: "a_stu_grade, a_user_name",
      s_grade: ["student"],
      s_seq: s_stu_seq_arr,
      s_addon_add_memo: "1",
      s_addon_lecture_time: "1",
      s_addon_stu_subject: "1",
      s_addon_link_user: "1",
      s_addon_daily_report_last: "1",
      s_addon_daily_report_last_addon_study_use: "",
      s_addon_daily_report_last_addon_book_use: "1",
      s_addon_study_det_by_daily_last: "",
      s_addon_textbook_det_by_daily_last: "1",
      s_addon_daily_report: "1",
      s_addon_daily_report_start_date: select_date,
      s_addon_daily_report_end_date: select_date,
      s_addon_daily_report_addon_study_use: "",
      s_addon_daily_report_addon_book_use: "",
      s_addon_daily_lecture_arr: "1",
      s_addon_todo: "1",
      s_addon_todo_start_date: select_date,
      s_addon_todo_end_date: select_date,
      s_addon_todo_s_todo_sort: "",
      s_addon_todo_elapse_time: "",
      s_addon_todo_s_state: "",
      s_addon_todo_addon_par: "",
      s_addon_todo_addon_file: "1",
      s_addon_attend: "1",
      s_addon_attend_start_date: select_date,
      s_addon_attend_end_date: select_date,
      s_attend_sort_detail: "",
      s_attend_start_date: select_date,
      s_attend_end_date: select_date,
      s_addon_todo_dailyc: "1",
      s_addon_todo_dailyc_start_date: select_date,
      s_addon_todo_dailyc_end_date: select_date,
      s_addon_desk_use: "1",
      s_addon_desk_use_start_date: select_date,
      s_addon_desk_use_end_date: select_date,
      s_addon_daily_prescribe: "1",
      s_addon_daily_prescribe_start_date: select_date,
      s_addon_daily_prescribe_end_date: select_date,
      s_addon_daily_prescribe_last: "1",
      s_addon_tstu_todo: "1",
      s_addon_tstu_todo_start_date: select_date,
      s_addon_tstu_todo_end_date: select_date,
      s_addon_tstu_todo_par_id: "daily_report",
      is_paging: "",
    };
    if (is_use_comp_study_textbook) {
      form_json_data.s_addon_daily_report_last_addon_study_use = "1";
      form_json_data.s_addon_study_det_by_daily_last = "1";
    }
    form_json_data["s_addon_todo_start_date"] = select_date;
    form_json_data["s_addon_todo_end_date"] = select_date;
    form_json_data["s_addon_home_work_file_start_date"] = select_date;
    form_json_data["s_addon_home_work_file_end_date"] = select_date;
    form_json_data["s_addon_plan_study_file_start_date"] = select_date;
    form_json_data["s_addon_plan_study_file_end_date"] = select_date;
    form_json_data["s_addon_attend_start_date"] = select_date;
    form_json_data["s_addon_attend_end_date"] = select_date;
    form_json_data["s_attend_start_date"] = select_date;
    form_json_data["s_attend_end_date"] = select_date;
    form_json_data["s_addon_desk_use_start_date"] = select_date;
    form_json_data["s_addon_desk_use_end_date"] = select_date;
    form_json_data["s_addon_todo_dailyc_start_date"] = select_date;
    form_json_data["s_addon_todo_dailyc_end_date"] = select_date;
    form_json_data["s_addon_daily_prescribe_start_date"] = select_date;
    form_json_data["s_addon_daily_prescribe_end_date"] = select_date;
    form_json_data["s_addon_tstu_todo_start_date"] = select_date;
    form_json_data["s_addon_tstu_todo_end_date"] = select_date;

    //하루전꺼부터 조회
    let tmp_start_date = form_json_data["s_addon_todo_start_date"];
    let tmp_start_date_json = DateFunc.get_date_json(new Date(tmp_start_date));
    let pre_date_change_num = -1;
    if (tmp_start_date_json.day == 1) {
      //일요일이면 3일뒤로이동(금요일부터 보이게한다.)
      pre_date_change_num = -3;
    }
    let pre_date_str = DateFunc.get_date_format(DateFunc.get_change_date(new Date(tmp_start_date), 'day', pre_date_change_num), "Y-m-d");
    form_json_data["s_addon_todo_start_date"] = pre_date_str;
    form_json_data["s_addon_home_work_file_start_date"] = pre_date_str;
    //데일리플랜 일주일 조회
    let week_date_change_num = -tmp_start_date_json.day;
    let week_date_change_end_num = 6 - tmp_start_date_json.day;
    let week_date_str = DateFunc.get_date_format(DateFunc.get_change_date(new Date(tmp_start_date), 'day', week_date_change_num), "Y-m-d");
    let week_date_end_str = DateFunc.get_date_format(DateFunc.get_change_date(new Date(tmp_start_date), 'day', week_date_change_end_num), "Y-m-d");
    form_json_data["s_addon_month_prescribe_start_date"] = week_date_str;
    form_json_data["s_addon_month_prescribe_end_date"] = week_date_end_str;

    form_json_data["s_addon_daily_report_start_date"] = select_date;
    form_json_data["s_addon_daily_report_end_date"] = select_date;

    form_json_data["s_addon_tstu_todo_start_date"] = week_date_str;
    form_json_data["s_addon_tstu_todo_end_date"] = week_date_end_str;

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user/user/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          response.data["data"]["info_arr"] = TodoInfoArrFunc.get_info_arr_by_filter({
            info_arr: response.data["data"]["info_arr"],
            list_opt: form_json_data,
            base_date_str: select_date,
            pre_date_str: pre_date_str,
          });
          let tmp_user_info_arr = response.data["data"]["info_arr"];
          let new_stu_info_arr = DailyReportTextListFunc.get_stu_info_arr_by_props({
            stu_info_arr: tmp_user_info_arr,
            select_date: select_date,
            user: user,
          });
          set_stu_info_arr(new_stu_info_arr);

          get_counsel_todo_by_ajax({
            stu_info_arr: new_stu_info_arr,
          });
          get_user_link_by_ajax({
            stu_info_arr: new_stu_info_arr,
          });
          get_comment_temp_memo_by_ajax({
            stu_info_arr: new_stu_info_arr
          });
          get_stu_par_report_by_ajax({
            stu_info_arr: new_stu_info_arr
          });
        }
      });
  };

  const get_select_stu_info_arr = () => {
    let select_stu_info_arr: any = [];
    for (let i = 0; i < stu_info_arr.length; i++) {
      let stu_info = stu_info_arr[i];
      if (strFunc.str_in_array(stu_info["a_seq"], check_seq_arr) != -1) {
        select_stu_info_arr.push(stu_info);
      }
    }
    return select_stu_info_arr;
  };
  const get_select_counsel_info_arr = () => {
    let select_counsel_info_arr: any = [];
    for (let i = 0; i < counsel_todo_arr.length; i++) {
      let row_counsel_todo = counsel_todo_arr[i];
      let tmp_counsel_pri_val = row_counsel_todo["a_ymd"] + "," + row_counsel_todo["a_seq"];
      if (strFunc.str_in_array(tmp_counsel_pri_val, check_counsel_seq_arr) != -1) {
        select_counsel_info_arr.push(row_counsel_todo);
      }
    }
    //유저 순서로 정렬
    let tmp_select_counsel_info_arr: any = [];
    for (let u_i = 0; u_i < stu_info_arr.length; u_i++) {
      let row_stu_info = stu_info_arr[u_i];
      for (let c_i = 0; c_i < select_counsel_info_arr.length; c_i++) {
        let row_counsel_todo = select_counsel_info_arr[c_i];
        if (row_counsel_todo["a_stu_seq"] == row_stu_info["a_seq"]) {
          tmp_select_counsel_info_arr.push(row_counsel_todo);
        }
      }
    }
    select_counsel_info_arr = tmp_select_counsel_info_arr;

    return select_counsel_info_arr;
  };

  const copy_clipboard_report = (inData: any) => {
    let opt_obj = {
      select_stu_info_arr: get_select_stu_info_arr(),
      ...inData
    };
    if (opt_obj.select_stu_info_arr.length == 0) {
      alert("선택된 학생이 없습니다.");
      return false;
    }
    save_comment_temp_memo_by_ajax({ select_stu_info_arr: opt_obj.select_stu_info_arr });

    let copy_text_arr: any = [];
    let line_break = "\n";
    for (let i = 0; i < opt_obj.select_stu_info_arr.length; i++) {
      let stu_info = opt_obj.select_stu_info_arr[i];
      let copy_text = "";

      copy_text += stu_info["report"];
      if (stu_info["comment"]) {
        copy_text += line_break;
        copy_text += stu_info["comment"];
      }
      if (stu_info["counsel_todo"]) {
        copy_text = stu_info["counsel_todo"]["a_content"];
      }

      copy_text_arr.push(copy_text);
    }

    navigator.clipboard.writeText(copy_text_arr.join(line_break + line_break));
    set_loading_data({
      is_display: true,
      text: "복사됨",
    });
    setTimeout(() => {
      set_loading_data({
        is_display: false,
        text: "로딩중..",
      });
    }, 500);
  };

  const get_comment_by_open_ai_ajax = (inData: any) => {
    let opt_obj = {
      select_stu_info_arr: get_select_stu_info_arr(),
      ...inData
    };
    if (opt_obj.select_stu_info_arr.length == 0) {
      alert("선택된 학생이 없습니다.");
      return false;
    }
    if (opt_obj.select_stu_info_arr.length != 1) {
      alert("1명만 선택해 주세요.");
      return false;
    }

    let copy_text_arr: any = [];
    let line_break = "\n";

    let tmp_select_stu_seq = "";
    for (let i = 0; i < opt_obj.select_stu_info_arr.length; i++) {
      let stu_info = opt_obj.select_stu_info_arr[i];
      tmp_select_stu_seq = stu_info["a_seq"];
      if (stu_info["counsel_todo"]) {
        alert("이미 상담이 등록되어 있습니다.");
        return false;
      }

      let copy_text = "";

      let stu_grade_str = "";
      for (let j = 0; j < select_stu_grade_option_arr.length; j++) {
        if (select_stu_grade_option_arr[j]["value"] == stu_info["a_stu_grade"]) {
          stu_grade_str = select_stu_grade_option_arr[j]["text"];
        }
      }
      let stu_gender_str = "";//user_school_name
      if (stu_info["a_gender"] == "m") {
        stu_gender_str = "남";
      } else if (stu_info["a_gender"] == "f") {
        stu_gender_str = "여";
      }
      copy_text += "학생이름: " + stu_info["a_user_name"].substring(1);
      copy_text += line_break;
      copy_text += stu_info["a_school_name"] + " " + stu_grade_str + " " + stu_gender_str;
      copy_text += line_break;
      copy_text += stu_info["report"];

      if (stu_info.daily_report_arr && stu_info.daily_report_arr.length > 0) {
        for (let daily_i = 0; daily_i < stu_info.daily_report_arr.length; daily_i++) {
          let daily_report = stu_info.daily_report_arr[daily_i];
          copy_text += line_break;
          copy_text += "(" + daily_report["a_subject"] + " " + daily_report["a_lecture_time"] + ") " + daily_report["a_memo"]
            + (daily_report["a_study_amount_memo"] ? "\n" + daily_report["a_study_amount_memo"] : "");
        }
      }

      if (stu_info["comment"]) {
        copy_text += line_break;
        copy_text += stu_info["comment"];
      }

      copy_text_arr.push(copy_text);
    }

    if (strFunc.is_empty(user.user_seq)) {
      return false;
    }
    let send_msg_json: any = {
      role: "user",
      content: copy_text_arr.join(""),
    };
    let form_json_data: any = {
      messages: [send_msg_json],
      goal_sort: "daily_plan_counsel",
      par_id: "user",
      par_seq: tmp_select_stu_seq,
    };
    set_loading_data({
      is_display: true,
      text: "AI 상담 생성중..",
    });
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/edu/openai/send_chat_comp', form_json_data, get_axios_data())
      .then((response) => {
        set_loading_data({
          is_display: false,
          text: "AI 상담 생성 완료",
        });
        if (response.data["result"] === "true") {
          let result_msg = response.data.data["message"];
          let change_stu_info_arr = [...stu_info_arr];
          for (let i = 0; i < change_stu_info_arr.length; i++) {
            let stu_info = change_stu_info_arr[i];
            if (stu_info["a_seq"] == tmp_select_stu_seq) {
              change_stu_info_arr[i]["comment"] = result_msg["content"];
            }
          }
          set_stu_info_arr(change_stu_info_arr);
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const get_counsel_todo_by_ajax = (inData: any) => {
    let opt_obj = {
      stu_info_arr: stu_info_arr,
      ...inData
    };
    let stu_seq_arr: any = [];
    for (let i = 0; i < opt_obj.stu_info_arr.length; i++) {
      stu_seq_arr.push(opt_obj.stu_info_arr[i]["a_seq"]);
    }
    if (stu_seq_arr.length == 0) {
      return false;
    }
    if (strFunc.is_empty(user.user_seq)) {
      return false;
    }
    let counsel_start_date = select_date;
    let counsel_end_date = select_date;
    if (select_date) {
      counsel_start_date = DateFunc.get_date_format(DateFunc.get_change_date(new Date(select_date), 'month', -1), "Y-m-01");;
      counsel_end_date = DateFunc.get_date_format(DateFunc.get_change_date(new Date(select_date), 'day', +5), "Y-m-d");;
    }
    let form_json_data: any = {
      "s_par_id": "daily_report",
      "s_stu_seq": stu_seq_arr,
      s_date_type: "a_reserve_date",
      s_start_date: counsel_start_date,
      s_end_date: counsel_end_date,
      "order_id": "a_reserve_date DESC, a_create_date DESC",
      "is_need_count": "",
      "is_need_info_arr": "1",
      "is_no_limit": "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/counsel_todo/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_counsel_todo_arr(response.data["data"]["info_arr"]);
          let new_stu_info_arr = DailyReportTextListFunc.get_stu_info_arr_by_counsel_added({
            stu_info_arr: opt_obj.stu_info_arr,
            counsel_todo_arr: response.data["data"]["info_arr"],
            select_date: select_date,
          });
          set_stu_info_arr(new_stu_info_arr);
        } else {

        }
      });
  };

  const get_user_link_by_ajax = (inData: any) => {
    let opt_obj = {
      stu_info_arr: stu_info_arr,
      ...inData
    };
    let stu_seq_arr: any = [];
    for (let i = 0; i < opt_obj.stu_info_arr.length; i++) {
      stu_seq_arr.push(opt_obj.stu_info_arr[i]["a_seq"]);
    }
    if (stu_seq_arr.length == 0) {
      return false;
    }
    if (strFunc.is_empty(user.user_seq)) {
      return false;
    }
    let form_json_data: any = {
      "s_stu_seq": stu_seq_arr,
      "s_type": "parent",
      "order_id": "a_order",
      "s_addon_user": "1",
      "is_need_count": "",
      "is_need_info_arr": "1",
      "is_no_limit": "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user_link/link/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_user_link_arr(response.data["data"]["info_arr"]);
        } else {

        }
      });
  };

  const wrtie_counsel_todo_by_ajax = (inData: any) => {
    let opt_obj = {
      select_stu_info_arr: get_select_stu_info_arr(),
      is_study_prescribe: false,
      ...inData
    };
    if (opt_obj.select_stu_info_arr.length == 0) {
      alert("선택된 학생이 없습니다.");
      return false;
    }
    if (strFunc.is_empty(user.user_seq)) {
      return false;
    }
    let write_counsel_arr: any = [];
    for (let i = 0; i < opt_obj.select_stu_info_arr.length; i++) {
      let stu_info = opt_obj.select_stu_info_arr[i];
      if (strFunc.is_empty(stu_info["counsel_todo"]) && stu_info["daily_report"]) {
        let row_daily_report = stu_info["daily_report"];
        let row_daily_report_pri_val = row_daily_report["a_ymd"] + "," + row_daily_report["a_seq"];
        let tmp_ymd = DateFunc.get_date_format(new Date(select_date), "Ymd");
        let tmp_content = stu_info["report"];

        let counsel_kind = "진도";
        let a_is_success = "1";
        let a_state = "complete";
        let a_sort1 = "퍼스널학습상담";
        if (opt_obj.is_study_prescribe) {
          counsel_kind = "학습처방";
          tmp_content = tmp_content.replace("1:1퍼스널 학습", "1:1퍼스널 학습처방");
          a_is_success = "";
          a_state = "ready";
          a_sort1 = "학습처방";
        }

        if (stu_info["comment"]) {
          tmp_content += "\n" + stu_info["comment"];
        }

        let tmp_a_reference: any = "";
        if (stu_info.daily_report_arr && stu_info.daily_report_arr.length > 0) {
          for (let dr_i = 0; dr_i < stu_info.daily_report_arr.length; dr_i++) {
            let daily_report = stu_info.daily_report_arr[dr_i];
            tmp_a_reference += "(" + daily_report["a_subject"] + " " + daily_report["a_lecture_time"] + ") " + daily_report["a_memo"] + (daily_report["a_study_amount_memo"] ? "\n" + daily_report["a_study_amount_memo"] : "");
          }
        }

        let w_counsel_todo_row: any = {
          "a_ymd": tmp_ymd,
          "a_seq": "",
          "a_stu_seq": stu_info["a_seq"],
          "a_stu_name": stu_info["a_user_name"],
          "a_sort1": a_sort1,
          "a_sort2": "상담",
          "a_is_public": "1",
          "a_kind": counsel_kind,

          "a_counsel_date": select_date,
          "a_reserve_date": select_date,
          "a_writer_seq": user.user_seq,
          "a_writer": user.user_name,
          "a_par_id": "daily_report",
          "a_par_seq": row_daily_report_pri_val,
          "a_counseler_seq": user.user_seq,
          "a_counseler": user.user_name,
          "a_title": "상담",
          "a_content": tmp_content,
          "a_feedback": "",
          "a_eval_score": "",
          "a_reference": tmp_a_reference,
          "a_is_success": a_is_success,
          "a_state": a_state,
        };
        write_counsel_arr.push(w_counsel_todo_row);
      }
    }
    if (write_counsel_arr.length == 0) {
      alert("상담 저장 할 내용이 없습니다.");
      return false;
    }

    if (confirm("상담내용을 저장하시겠습니까?") == false) {
      return false;
    }

    save_comment_temp_memo_by_ajax({ select_stu_info_arr: opt_obj.select_stu_info_arr });

    let form_json_data: any = {
      data_arr: write_counsel_arr,
      is_default_val: "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/counsel_todo/write', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert("상담내용이 저장되었습니다.");
          get_counsel_todo_by_ajax({});
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const get_comment_temp_memo_by_ajax = (inData: any) => {
    let opt_obj = {
      stu_info_arr: stu_info_arr,
      ...inData
    };
    let s_user_seq_arr: any = [];
    for (let i = 0; i < opt_obj.stu_info_arr.length; i++) {
      s_user_seq_arr.push(opt_obj.stu_info_arr[i]["a_seq"]);
    }

    let form_json_data: any = {
      s_user_seq: s_user_seq_arr,
      s_par_id: "user",
      s_par_seq: s_user_seq_arr,
      s_sort1: "daily_comment",
      order_id: "a_date DESC, a_update_date DESC",
      is_need_count: "",
      is_need_info_arr: "1",
      is_no_limit: "1",
      max_limit_num: 1000,
    };
    if (strFunc.is_empty(user.user_seq)) {
      return false;
    }
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user/user_temp_memo/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_temp_memo_arr(response.data["data"]["info_arr"]);
          let change_stu_info_arr = DailyReportTextListFunc.get_stu_info_arr_by_temp_memo_added({
            stu_info_arr: opt_obj.stu_info_arr,
            temp_memo_arr: response.data["data"]["info_arr"],
            select_date: select_date,
          });
          set_stu_info_arr(change_stu_info_arr);
        }
      });
  };

  const get_stu_par_report_by_ajax = (inData: any) => {
    let opt_obj = {
      stu_info_arr: stu_info_arr,
      ...inData
    };
    let s_user_seq_arr: any = [];
    for (let i = 0; i < opt_obj.stu_info_arr.length; i++) {
      s_user_seq_arr.push(opt_obj.stu_info_arr[i]["a_seq"]);
    }

    let form_json_data: any = {
      s_user_seq: s_user_seq_arr,
      s_par_id: "daily_report",
      s_stu_seq: s_user_seq_arr,
      order_id: "a_date DESC, a_update_date DESC",
      s_date_type: "a_date",
      s_start_date: select_date,
      s_end_date: select_date,
      is_need_count: "",
      is_need_info_arr: "1",
      is_no_limit: "1",
      max_limit_num: 1000,
    };
    if (strFunc.is_empty(user.user_seq)) {
      return false;
    }
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/stu_par_report/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_stu_par_report_arr(response.data["data"]["info_arr"]);
        }
      });
  };

  const get_mcomp_info_by_ajax = () => {
    if (strFunc.is_empty(user.comp_seq)) {
      return false;
    }
    let form_json_data: any = {
      s_seq: user.comp_seq,
      is_addon_data: "1",
      is_paging: "",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/mcomp/mcomp/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (response.data["data"]["info_arr"].length > 0) {
            set_mcomp_info(response.data["data"]["info_arr"][0]);
          }
        }
      });
  };

  const get_pre_comment_info_by_arr = (inData: any) => {
    let opt_obj = {
      row_data: {},
      ...inData
    };
    let pre_info = null;
    for (let i = 0; i < temp_memo_arr.length; i++) {
      let row = temp_memo_arr[i];
      if (row["a_date"] == opt_obj.row_data["a_date"]
        && row["a_user_seq"] == opt_obj.row_data["a_user_seq"]
        && row["a_sort1"] == opt_obj.row_data["a_sort1"]
      ) {
        pre_info = row;
        break;
      }
    }
    return pre_info;
  };

  const save_comment_temp_memo_by_ajax = (inData: any) => {
    let opt_obj = {
      select_stu_info_arr: get_select_stu_info_arr(),
      ...inData
    };
    if (opt_obj.select_stu_info_arr.length == 0) {
      return false;
    }
    let write_temp_memo_arr: any = [];
    for (let i = 0; i < opt_obj.select_stu_info_arr.length; i++) {
      let select_stu_info = opt_obj.select_stu_info_arr[i];
      let tmp_ymd = DateFunc.get_date_format(new Date(select_date), "Ymd");
      let tmp_row: any = {
        a_ymd: tmp_ymd,
        a_seq: "",
        a_date: select_date,
        a_user_seq: select_stu_info["a_seq"],
        a_user_name: select_stu_info["a_user_name"],
        a_writer_seq: user.user_seq,
        a_writer_name: user.user_name,
        a_par_id: "user",
        a_par_seq: select_stu_info["a_seq"],
        a_sort1: "daily_comment",
        a_sort2: "",
        a_content: select_stu_info["comment"],
        a_content2: select_stu_info["report"],
      };
      let tmp_pre_info: any = get_pre_comment_info_by_arr({ row_data: tmp_row });
      if (tmp_pre_info) {
        tmp_row = {
          ...tmp_row,
        }
        if (tmp_pre_info["a_ymd"] && tmp_pre_info["a_seq"]) {
          tmp_row["a_ymd"] = tmp_pre_info["a_ymd"];
          tmp_row["a_seq"] = tmp_pre_info["a_seq"];
          tmp_row["a_create_date"] = tmp_pre_info["a_create_date"];
        }
      }
      write_temp_memo_arr.push(tmp_row);
    }
    if (strFunc.is_empty(user.user_seq)) {
      return false;
    }
    let form_json_data: any = {
      data_arr: write_temp_memo_arr,
      is_default_val: "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user/user_temp_memo/write', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          get_comment_temp_memo_by_ajax({});
        }
      });
  };

  const write_stu_par_report_by_ajax = (inData: any) => {
    let opt_obj = {
      select_counsel_info_arr: get_select_counsel_info_arr(),
      ...inData
    };

    let select_counsel_info_arr = opt_obj.select_counsel_info_arr;
    if (select_counsel_info_arr.length == 0) {
      alert("선택된 상담이 없습니다.");
      return false;
    }

    let write_stu_par_report_arr: any = [];
    let tmp_ymd = DateFunc.get_date_format(new Date(select_date), "Ymd");
    let tmp_date = DateFunc.get_date_format(new Date(select_date), "Y-m-d");
    for (let c_i = 0; c_i < select_counsel_info_arr.length; c_i++) {
      let row_counsel = select_counsel_info_arr[c_i];
      //다른날짜있는지 확인
      if(tmp_date!=row_counsel["a_reserve_date"]){
        alert("상담등록날짜가 다른것이 있습니다." +row_counsel["a_reserve_date"]+" "+ row_counsel["a_stu_name"]);
        return false;
      }
      //이미있는지확인
      let tmp_is_exist = false;
      for (let i = 0; i < stu_par_report_arr.length; i++) {
        let row_report = stu_par_report_arr[i];
        if (row_report["a_stu_seq"] == row_counsel["a_stu_seq"]
          && row_report["a_date"] == row_counsel["a_reserve_date"]
        ) {
          tmp_is_exist = true;
          alert("이미 전송된 데일리진도상담이 있습니다." + row_counsel["a_stu_name"]);
          return false;
        }
      }
      if (!tmp_is_exist) {
        write_stu_par_report_arr.push({
          a_ymd: tmp_ymd,
          a_seq: "",
          a_date: tmp_date,
          a_stu_seq: row_counsel["a_stu_seq"],
          a_stu_name: row_counsel["a_stu_name"],
          a_writer_seq: user.user_seq,
          a_writer: user.user_name,
          a_par_id: "daily_report",
          a_par_seq: "",
          a_title: "데일리진도상담",
          a_content: row_counsel["a_content"],
        });
      }
    }

    if (write_stu_par_report_arr.length == 0) {
      alert("전송할 내용이 없습니다.");
      return false;
    }

    if (confirm("데일리진도상담을 전송하시겠습니까? " + write_stu_par_report_arr.length + "개") == false) {
      return false;
    }

    let form_json_data: any = {
      data_arr: write_stu_par_report_arr,
      is_default_val: "1",
      is_send_report_msg: "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/stu_par_report/write', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          get_stu_par_report_by_ajax({});
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const delete_stu_par_report_by_ajax = (inData: any) => {
    let opt_obj = {
      select_stu_par_report_arr: [],
      ...inData
    };
    let select_stu_par_report_arr = opt_obj.select_stu_par_report_arr;
    if (select_stu_par_report_arr.length == 0) {
      alert("삭제할 리포트가 없습니다.");
      return false;
    }

    if (confirm("리포트를 삭제하시겠습니까?") == false) {
      return false;
    }

    let form_json_data: any = {
      data_arr: select_stu_par_report_arr,
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/stu_par_report/delete', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          get_stu_par_report_by_ajax({});
        } else {
          alert(response.data["msg"]);
        }
      });
  }

  const open_view_counsel_todo = (inData: any) => {
    let opt_obj = {
      selected_stu_arr: get_select_stu_info_arr(),
      select_date: select_date,
      ...inData
    };
    let selected_stu_arr = opt_obj.selected_stu_arr;

    if (selected_stu_arr.length == 0) {
      alert("선택이 필요합니다.");
      return false;
    }
    setPopupData({
      ...popupData,
      isOpen: true,
      sort: "view_ctodo",
      title: "상담일정 보기",
      stu_info_arr: selected_stu_arr,
      select_date: opt_obj.select_date,
      ...inData
    });
  };

  const open_send_sms_popup = (inData: any) => {
    let opt_obj = {
      select_counsel_info_arr: get_select_counsel_info_arr(),
      ...inData
    };
    let select_counsel_info_arr = opt_obj.select_counsel_info_arr;
    if (select_counsel_info_arr.length == 0) {
      alert("선택된 상담이 없습니다.");
      return false;
    }

    let sms_data_arr: any = [];
    for (let i = 0; i < select_counsel_info_arr.length; i++) {
      let counsel_info = select_counsel_info_arr[i];
      let stu_info = null;
      for (let j = 0; j < stu_info_arr.length; j++) {
        let row_stu_info = stu_info_arr[j];
        if (row_stu_info["a_seq"] == counsel_info["a_stu_seq"]) {
          stu_info = row_stu_info;
          break;
        }
      }
      if (stu_info == null) {
        continue;
      }
      let user_par_link = null;
      for (let j = 0; j < user_link_arr.length; j++) {
        let row_user_link = user_link_arr[j];
        if (row_user_link["a_stu_seq"] == stu_info["a_seq"]) {
          user_par_link = row_user_link;
          break;
        }
      }
      if (user_par_link == null) {
        continue;
      }
      if (strFunc.is_empty(user_par_link.par_info)) {
        continue;
      }
      if (strFunc.is_empty(user_par_link.par_info["a_user_phone"])) {
        continue;
      }
      sms_data_arr.push({
        phone_num: user_par_link.par_info["a_user_phone"],
        user_name: stu_info["a_user_name"],
        user_seq: stu_info["a_seq"],
        content: counsel_info["a_content"],
      });
    }

    setPopupData({
      ...popupData,
      isOpen: true,
      sort: "send_sms_each",
      title: "문자보내기",
      sms_data_arr: sms_data_arr,
      ...inData
    });
  };

  const open_send_local_katalk_popup = (inData: any) => {
    let opt_obj = {
      selected_stu_arr: get_select_stu_info_arr(),
      ...inData
    };
    let selected_stu_arr = opt_obj.selected_stu_arr;

    let line_break = "\n";
    let msg_arr = [];
    for (let i = 0; i < selected_stu_arr.length; i++) {
      let stu_info = selected_stu_arr[i];

      let room_name = "";
      if (stu_info.add_memo_info) {
        room_name = stu_info.add_memo_info["a_kakaotalk_parent_room_name"];
      }

      let message = stu_info["report"];
      if (stu_info["comment"]) {
        message += line_break;
        message += stu_info["comment"];
      }
      if (stu_info["counsel_todo"]) {
        message = stu_info["counsel_todo"]["a_content"];
      }

      let msg_row = {
        room_name: room_name,
        message: message,
      };
      msg_arr.push(msg_row);
    }

    setPopupData({
      ...popupData,
      isOpen: true,
      sort: "send_local_katalk",
      title: "카톡 보내기(PC카톡)",
      msg_arr: msg_arr,
      ...inData
    });
  };

  const open_send_local_katalk_counsel_todo_popup = (inData: any) => {
    let opt_obj = {
      select_counsel_info_arr: get_select_counsel_info_arr(),
      ...inData
    };
    let select_counsel_info_arr = opt_obj.select_counsel_info_arr;
    let counsel_todo_pri_val_arr: any = [];
    for (let i = 0; i < select_counsel_info_arr.length; i++) {
      let row_counsel_todo = select_counsel_info_arr[i];
      let tmp_counsel_pri_val = row_counsel_todo["row_pri_val"];
      counsel_todo_pri_val_arr.push(tmp_counsel_pri_val);
    }

    setPopupData({
      ...popupData,
      isOpen: true,
      sort: "send_local_katalk_counsel_todo",
      title: "카톡 보내기(PC카톡)",
      counsel_todo_pri_val_arr: counsel_todo_pri_val_arr,
      ...inData
    });
  };

  return (
    <div className={Style.report_div_wrap}>
      <div className={Style.report_div_con}>
        <div style={{ position: "relative" }}>
          <div>{select_date}</div>
          <label>
            <input type="checkbox" onChange={check_all_stu} style={{ width: "18px", height: "18px" }} /> 전체선택
          </label>
          <span style={{ position: "absolute", right: "5px", top: "5px" }}>
            <label>
              <input type="checkbox" onChange={check_all_counsel} /> 상담 전체선택
            </label>
            <button className="btn btn-yellow ml-1" onClick={() => { open_send_local_katalk_counsel_todo_popup({}); }} >PC카톡</button>
            {is_exist_katalk_send &&
              <>
                {/* <button className="btn btn-dark ml-1" onClick={() => { open_send_sms_popup({}); }}>선택문자보내기</button> */}
                <button className="btn btn-dark ml-1"
                  onClick={() => { write_stu_par_report_by_ajax({}); }}
                >학부모리포트전송</button>
              </>
            }
          </span>
        </div>
        <div ref={content_scroll_ref} style={{ flexGrow: 1, overflowY: "auto" }}>
          <CardListArea
            select_date={select_date}
            stu_info_arr={stu_info_arr}
            set_stu_info_arr={set_stu_info_arr}
            check_seq_arr={check_seq_arr}
            set_check_seq_arr={set_check_seq_arr}
            check_counsel_seq_arr={check_counsel_seq_arr}
            set_check_counsel_seq_arr={set_check_counsel_seq_arr}
            copy_clipboard_report={copy_clipboard_report}
            get_comment_by_open_ai_ajax={get_comment_by_open_ai_ajax}
            counsel_todo_arr={counsel_todo_arr}
            stu_par_report_arr={stu_par_report_arr}
            is_exist_katalk_send={is_exist_katalk_send}
            write_stu_par_report_by_ajax={write_stu_par_report_by_ajax}
            delete_stu_par_report_by_ajax={delete_stu_par_report_by_ajax}
            wrtie_counsel_todo_by_ajax={wrtie_counsel_todo_by_ajax}
            open_view_counsel_todo={open_view_counsel_todo}
            open_send_local_katalk_popup={open_send_local_katalk_popup}
            open_send_local_katalk_counsel_todo_popup={open_send_local_katalk_counsel_todo_popup}
          ></CardListArea>
        </div>
        <div className="text-center mt-2">
          <button className="btn btn-orange ml-1" onClick={() => { wrtie_counsel_todo_by_ajax({}); }} >상담등록</button>
          {/* <button className="btn btn-yellow ml-1" onClick={() => { open_send_local_katalk_popup({}); }} >PC카톡</button> */}
          <button className="btn btn-dark ml-1" onClick={() => { copy_clipboard_report({}); }} >복사</button>
          <button className="btn btn-dark ml-1" onClick={() => { copy_clipboard_report({ select_stu_info_arr: stu_info_arr }); }} >모두복사</button>
          <button className="btn btn-dark ml-1" onClick={() => { open_view_counsel_todo({ selected_stu_arr: stu_info_arr }); }} >상담보기</button>
          <button className="btn btn-dark ml-1" onClick={() => { myProps.closePopup(); }}>닫기</button>
        </div>
      </div>
      {loading_data.is_display &&
        <LoadingComponent text={loading_data.text} is_display={loading_data.is_display}></LoadingComponent>
      }
      {popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} has_header={popupData.has_header} >
          {popupData.sort == "view_ctodo" &&
            <ViewCounselTodoOfDay
              select_date={popupData.select_date}
              stu_info_arr={popupData.stu_info_arr}
              list_opt={{}}
              show_write_diary_page={() => { }}
              callback={() => { get_counsel_todo_by_ajax({}); }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></ViewCounselTodoOfDay>
          }
          {popupData.sort == "send_sms_each" &&
            <SendSmsEachPopup
              sms_title="데일리진도 보고서"
              sms_data_arr={popupData.sms_data_arr}
              callback_refresh={() => { get_counsel_todo_by_ajax({}); }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></SendSmsEachPopup>
          }
          {popupData.sort == "send_local_katalk" &&
            <SendLocalKatalkPopup
              msg_arr={popupData.msg_arr}
              callback_refresh={() => { get_counsel_todo_by_ajax({}); }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></SendLocalKatalkPopup>
          }
          {popupData.sort == "send_local_katalk_counsel_todo" &&
            <SendLocalKatalkCounselPopup
              counsel_todo_pri_val_arr={popupData.counsel_todo_pri_val_arr}
              callback_refresh={() => { get_counsel_todo_by_ajax({}); }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></SendLocalKatalkCounselPopup>
          }
        </LayerPopup>
      }
    </div>
  );
};
export default DailyReportTextListPopup;